import PropTypes from 'prop-types'
import ContentfulJsonLdBlocks from '../../../src/components/shared/ContentfulJsonLdBlocks'
import React from 'react'
import Layout from '../../../src/components/layouts'
import BlogListingService from '../../../src/services/BlogListingService'
import { BLOG_LISTING_PAGE_SIZE } from '../../../src/services/blogListing/constants'
import BlogPage from '../../../src/components/pages/Blog'
import { generateSeoData } from '../../../src/common/nextSeoUtils'
import { getFullUrlFromReq } from '../../../src/common/serverUtils'
import logger from '../../../src/common/logger'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { getMegamenuData } from 'src/common/back/megamenu'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'

export async function getServerSideProps(context) {
  const {
    params: { pid: page = 1 },
    req,
    preview,
  } = context
  let megamenuData = null
  let categories = []
  let posts = []
  const currentPage = Number(page)
  if (!currentPage || currentPage < 1) {
    return { notFound: true }
  }

  if (currentPage === 1) {
    return {
      redirect: {
        destination: '/blog/',
      },
    }
  }

  let jsonLdSchemas = null

  try {
    const [listingResult, jsonLd] = await Promise.all([
      BlogListingService.getInstance().getListing({
        page: currentPage,
        limit: BLOG_LISTING_PAGE_SIZE,
        preview,
      }),
      getContentfulJsonLd('blog/'),
    ])
    posts = listingResult.posts
    categories = listingResult.posts.categories
    jsonLdSchemas = jsonLd
  } catch (error) {
    logger.error('Blog page: GraphQL listing failed', { currentPage, error })

    return { notFound: true }
  }

  if (posts.items.length < 1) {
    return {
      notFound: true,
    }
  }

  const pagePid = ['blog', 'page', page]
  const { canonicalUrl } = getFullUrlFromReq(req, pagePid)
  const seoData = generateSeoData({
    title: `Blog - All Articles | Page ${currentPage} of ${posts.countOfPages} | Freedom Debt Relief`,
    url: canonicalUrl,
    description: `Financial information and advice on debt relief, debt consolidation, home equity, personal finance tips and more. | Page ${currentPage} of ${posts.countOfPages}`,
  })

  try {
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    logger.error(`Blog page: failed to get megamenu`, { error })
  }

  return {
    props: {
      categories,
      posts,
      seoData,
      page,
      megamenuData: megamenuData || null,
      jsonLdSchemas,
    },
  }
}

const BlogPages = ({
  posts,
  categories,
  seoData,
  page,
  megamenuData,
  jsonLdSchemas,
}) => (
  <Layout footerClassName="max-w-1400" megamenuData={megamenuData}>
    <WithSeoOverrides {...seoData} />
    <BlogPage categories={categories} posts={posts} />
    <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
  </Layout>
)

BlogPages.propTypes = {
  categories: PropTypes.array.isRequired,
  posts: PropTypes.object.isRequired,
  seoData: PropTypes.object.isRequired,
  page: PropTypes.string,
}

export default BlogPages
